module.exports = __webpack_public_path__ + "static/img/jianda.e506799.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/jianda.png
// module id = XHg7
// module chunks = 96